import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/authContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { acceptOptin, getOptIn } from '../../services/optIn';
import { errorToast } from '../../utils/toast';
import Button from '../Button';
import RoundedCheckbox from '../Input/RoundedCheckbox';
import {
  Box,
  Container,
  ContainerButton,
  ContainerCard,
  ContainerCheckBox,
  ContainerContent,
  Content,
  Header,
  Title,
  TitleCheckBox,
} from './styles';

const OptIn: React.FC = () => {
  const [checked, setChecked] = useState(false);
  const { user, setData, signOut } = useAuth();
  const [optinText, setOptinText] = useState<string>('');
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.optIn);

  const handleRoute = async () => {
    const res = await acceptOptin(user);
    if (res.result === 'success') {
      setData(oldValue => {
        return {
          ...oldValue,
          optin: 1,
        };
      });
    } else {
      errorToast({ message: res.message });
    }
  };
  useEffect(() => {
    getOptIn().then(response => {
      setOptinText(response.param.par_valor);
    });
  }, []);

  return (
    <Container>
      <ContainerCard>
        <Box>
          <Header>
            <Title>{tp('title')}</Title>
          </Header>
          <ContainerContent>
            <ContainerContent>
              <Content>{optinText}</Content>
            </ContainerContent>
            <ContainerCheckBox>
              <RoundedCheckbox
                id="checked"
                isChecked={checked}
                onClick={() => setChecked(!checked)}
              />
              <TitleCheckBox>{tp('checkboxText')}</TitleCheckBox>
            </ContainerCheckBox>
            <ContainerButton>
              <Button
                title={tp('buttons.refuse')}
                onClick={() => {
                  signOut();
                }}
              />
              <Button
                onClick={handleRoute}
                title={tp('buttons.accept')}
                style={{ marginLeft: 10 }}
                disabled={!checked}
              />
            </ContainerButton>
          </ContainerContent>
        </Box>
      </ContainerCard>
    </Container>
  );
};

export default OptIn;
